const SOUND_KEY = "itz_sound_on";
let ctx = null;

export const soundOn = () => localStorage.getItem(SOUND_KEY) !== "0";
export const setSoundOn = (v) => localStorage.setItem(SOUND_KEY, v ? "1" : "0");

export const SOUNDS = [
  ["coin", "Münzen & Punkte"], ["fanfare", "Gewinn-Fanfare"], ["tick", "Glücksrad-Klicken"], ["drumroll", "Trommelwirbel"],
  ["scratch", "Rubbellose"], ["clash", "Duelle (Schwerter)"], ["whoosh", "Wisch-Effekte"], ["lose", "Leider verloren"],
  ["alarm", "Alarm & Erinnerungen"], ["kiss", "Geschenk: Herz mit Handkuss"], ["lion", "Geschenk: Miauender Löwe"],
  ["stars", "Geschenk: Sternenregen"], ["thanks", "Danke-Herz"], ["intro", "Begrüßung (Glitzer-Ton)"], ["vault", "Goldener Tresor"], ["twohearts", "Zwei Herzen"], ["runner", "Herz-Läufer"], ["candy", "Zuckerherz Saga"],
];
const OFF_KEY = "itz_sound_off";
const VOL_KEY = "itz_sound_volume";
const offList = () => { try { return JSON.parse(localStorage.getItem(OFF_KEY) || "[]"); } catch { return []; } };
export const soundEnabled = (id) => !offList().includes(id);
export const setSoundEnabled = (id, v) => localStorage.setItem(OFF_KEY, JSON.stringify(v ? offList().filter((x) => x !== id) : [...new Set([...offList(), id])]));
export const getVolume = () => { const v = parseFloat(localStorage.getItem(VOL_KEY)); return Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : 0.8; };
const on = (id) => soundOn() && soundEnabled(id) && getVolume() > 0;

let master = null;
const out = (a) => {
  if (!master) { master = a.createGain(); master.gain.value = getVolume(); master.connect(a.destination); }
  return master;
};
export const setVolume = (v) => { localStorage.setItem(VOL_KEY, String(v)); if (master) master.gain.value = v; };

const SFX = ["coin", "coin_big", "tick", "fanfare", "clash", "scratch", "drumroll", "whoosh", "lose", "alarm", "kiss", "lion", "stars"];
const BUF = {};
const loadAll = (a) => SFX.forEach((n) => {
  if (BUF[n] !== undefined) return;
  BUF[n] = null;
  fetch(`/sounds/${n}.mp3`).then((r) => r.arrayBuffer()).then((b) => a.decodeAudioData(b)).then((d) => { BUF[n] = d; }).catch(() => {});
});

const audio = () => {
  if (!ctx) { const A = window.AudioContext || window.webkitAudioContext; if (!A) return null; ctx = new A(); loadAll(ctx); }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
};

// plays a studio sample; false when not loaded yet (caller falls back to synth)
const sample = (a, name, { rate = 1, vol = 0.8, offset = 0, dur } = {}) => {
  const buf = BUF[name];
  if (!buf) return false;
  const s = a.createBufferSource(), g = a.createGain();
  s.buffer = buf; s.playbackRate.value = rate; g.gain.value = vol;
  s.connect(g).connect(out(a));
  const t = a.currentTime;
  if (dur) { g.gain.setValueAtTime(vol, t + Math.max(0, dur - 0.12)); g.gain.linearRampToValueAtTime(0.0001, t + dur); }
  s.start(t, offset, dur);
  return true;
};

export function playGiftSound(gift) {
  if (!on(gift)) return;
  const a = audio(); if (!a) return;
  if (!sample(a, gift, { vol: 0.9 })) setTimeout(() => on(gift) && sample(a, gift, { vol: 0.9 }), 600);
}

const SFX_FILE = { thanks: ["kiss", 1.6] };
export function playSfx(id) {
  if (!on(id)) return;
  const a = audio(); if (!a) return;
  const [file, dur] = SFX_FILE[id] || [id];
  const go = () => sample(a, file, { vol: 0.85, dur });
  if (!go()) setTimeout(go, 600);
}

export function previewSound(id) {
  const a = audio(); if (!a) return;
  if (["kiss", "lion", "stars"].includes(id)) { sample(a, id, { vol: 0.9 }); return; }
  const [file, dur] = SFX_FILE[id] || [id];
  sample(a, file, { vol: 0.85, dur: dur || (id === "drumroll" || id === "alarm" ? 2 : undefined) });
}

const tone = (a, freq, start, dur, type = "sine", vol = 0.12) => {
  const o = a.createOscillator(), g = a.createGain();
  o.type = type; o.frequency.setValueAtTime(freq, a.currentTime + start);
  g.gain.setValueAtTime(0.0001, a.currentTime + start);
  g.gain.exponentialRampToValueAtTime(vol, a.currentTime + start + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, a.currentTime + start + dur);
  o.connect(g).connect(out(a)); o.start(a.currentTime + start); o.stop(a.currentTime + start + dur + 0.05);
};

// tension for the bankrupt tease: drumroll + heartbeat thumps + vibration
export function playSuspense() {
  if (!on("drumroll")) return;
  const a = audio(); if (!a) return;
  sample(a, "drumroll", { vol: 0.75, dur: 1.5 });
  [0, 0.26, 0.72, 0.98].forEach((t, i) => { tone(a, 70, t, 0.2, "sine", 0.4); tone(a, 140, t, 0.12, "triangle", i % 2 ? 0.05 : 0.08); });
  tone(a, 220, 0, 1.4, "sawtooth", 0.025);
  navigator.vibrate?.([70, 110, 70, 330, 70, 110, 70]);
}

// "Kling" that climbs with the combo level
export function playCoin(level = 1) {
  if (!on("coin")) return;
  const a = audio(); if (!a) return;
  if (sample(a, level >= 6 ? "coin_big" : "coin", { rate: Math.pow(1.04, Math.min(level - 1, 12)), vol: 0.7 })) return;
  const base = 880 * Math.pow(1.06, Math.min(level - 1, 12));
  tone(a, base, 0, 0.18, "triangle"); tone(a, base * 1.5, 0.07, 0.32, "triangle", 0.1);
}

export function playTick() {
  if (!on("tick")) return;
  const a = audio(); if (a && !sample(a, "tick", { vol: 0.5, dur: 0.12 })) tone(a, 1600, 0, 0.03, "square", 0.03);
}

export function playFanfare() {
  if (!on("fanfare")) return;
  const a = audio(); if (!a) return;
  if (sample(a, "fanfare", { vol: 0.75 })) return;
  [523, 659, 784, 1047, 1319].forEach((f, i) => tone(a, f, i * 0.11, 0.35, "triangle", 0.12));
  tone(a, 1568, 0.6, 0.8, "sine", 0.08);
}

const COLORS = ["#F43F5E", "#EC4899", "#D946EF", "#FBBF24", "#FB7185", "#FDE68A"];

export function confetti({ x = innerWidth / 2, y = innerHeight / 2, count = 40, spread = 1, colors = COLORS } = {}) {
  const box = document.createElement("div");
  box.className = "fx-layer";
  for (let i = 0; i < count; i++) {
    const p = document.createElement("i");
    const ang = Math.random() * Math.PI * 2, dist = (80 + Math.random() * 180) * spread;
    p.className = "fx-confetti";
    p.style.cssText = `left:${x}px;top:${y}px;background:${colors[i % colors.length]};--dx:${Math.cos(ang) * dist}px;--dy:${Math.sin(ang) * dist - 60}px;--r:${Math.random() * 720 - 360}deg;animation-delay:${Math.random() * 80}ms;${Math.random() > 0.5 ? "border-radius:50%;" : ""}`;
    box.appendChild(p);
  }
  document.body.appendChild(box);
  setTimeout(() => box.remove(), 1600);
}

export function flyCoins({ count = 6, from } = {}) {
  const target = [...document.querySelectorAll('[data-testid="header-points-badge"],[data-testid="mobile-points-badge"]')].find((el) => el.offsetParent);
  if (!target) return;
  const t = target.getBoundingClientRect();
  const sx = from?.x ?? innerWidth / 2, sy = from?.y ?? innerHeight / 2;
  const box = document.createElement("div");
  box.className = "fx-layer";
  for (let i = 0; i < count; i++) {
    const c = document.createElement("i");
    c.className = "fx-coin";
    c.style.cssText = `left:${sx + (Math.random() - 0.5) * 60}px;top:${sy + (Math.random() - 0.5) * 40}px;--tx:${t.left + t.width / 2 - sx}px;--ty:${t.top + t.height / 2 - sy}px;animation-delay:${300 + i * 70}ms`;
    box.appendChild(c);
  }
  document.body.appendChild(box);
  setTimeout(() => box.remove(), 1800 + count * 70);
}

// small celebratory pop for success moments (post, comment, friendship)
export function successPop(el) {
  const r = el?.getBoundingClientRect?.();
  confetti({ x: r ? r.left + r.width / 2 : innerWidth / 2, y: r ? r.top + r.height / 2 : innerHeight / 2, count: 28, spread: 0.7 });
  playCoin(2);
}

// emojis float up from a button (likes / reactions)
export function floatEmojis(el, emoji = "❤️", count = 7) {
  if (!el) return;
  const r = el.getBoundingClientRect();
  const box = document.createElement("div");
  box.className = "fx-layer";
  for (let i = 0; i < count; i++) {
    const s = document.createElement("span");
    s.className = "fx-emoji";
    s.textContent = emoji;
    s.style.cssText = `left:${r.left + r.width / 2}px;top:${r.top + r.height / 2}px;--dx:${(Math.random() - 0.5) * 90}px;--dy:${-70 - Math.random() * 80}px;--s:${0.7 + Math.random() * 0.7};animation-delay:${i * 45}ms`;
    box.appendChild(s);
  }
  document.body.appendChild(box);
  setTimeout(() => box.remove(), 1400);
}

const noise = (a, start, dur, vol = 0.08, freq = 3000) => {
  const len = Math.floor(a.sampleRate * dur), buf = a.createBuffer(1, len, a.sampleRate), d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / len);
  const src = a.createBufferSource(), f = a.createBiquadFilter(), g = a.createGain();
  src.buffer = buf; f.type = "bandpass"; f.frequency.value = freq; g.gain.value = vol;
  src.connect(f).connect(g).connect(out(a)); src.start(a.currentTime + start);
};

// metallic swords clash
export function playClash() {
  if (!on("clash")) return;
  const a = audio(); if (!a) return;
  if (sample(a, "clash", { vol: 0.75 })) return;
  noise(a, 0, 0.25, 0.25, 4200); tone(a, 1975, 0, 0.5, "triangle", 0.07); tone(a, 2637, 0.02, 0.45, "sine", 0.05);
  noise(a, 0.32, 0.2, 0.2, 3600); tone(a, 1760, 0.32, 0.5, "triangle", 0.06);
}

let lastScratch = 0;
export function playScratch() {
  if (!on("scratch")) return;
  const a = audio(); if (!a) return;
  const n = performance.now();
  if (n - lastScratch < 70) return;
  lastScratch = n;
  if (!sample(a, "scratch", { vol: 0.6, offset: Math.random() * 0.7, dur: 0.14, rate: 0.9 + Math.random() * 0.2 })) noise(a, 0, 0.06, 0.06, 2200 + Math.random() * 1500);
}

export function playDrumroll(ms = 900) {
  if (!on("drumroll")) return;
  const a = audio(); if (!a) return;
  if (sample(a, "drumroll", { vol: 0.7, dur: Math.min(ms / 1000, 3) })) return;
  for (let t = 0; t < ms / 1000; t += 0.05) tone(a, 110 + Math.random() * 20, t, 0.05, "square", 0.03 + t * 0.03);
}

export function playWhoosh() {
  if (!on("whoosh")) return;
  const a = audio(); if (a && !sample(a, "whoosh", { vol: 0.6 })) [0, 0.05, 0.1].forEach((s, i) => noise(a, s, 0.25, 0.05, 800 + i * 700));
}

export function playLose() {
  if (!on("lose")) return;
  const a = audio(); if (a && !sample(a, "lose", { vol: 0.7 })) [392, 370, 349, 262].forEach((f, i) => tone(a, f, i * 0.18, 0.3, "triangle", 0.09));
}

export function unlockAudio() { audio(); }

export const sfxCore = { audio, out, sample, on };

export function playAlarm(seconds = 3) {
  if (!on("alarm")) return;
  const a = audio(); if (!a) return;
  if (sample(a, "alarm", { vol: 0.8, dur: Math.min(seconds, 3) })) return;
  const o = a.createOscillator(), g = a.createGain(), lfo = a.createOscillator(), lg = a.createGain();
  o.type = "sawtooth"; o.frequency.value = 760;
  lfo.type = "triangle"; lfo.frequency.value = 2.2; lg.gain.value = 260;
  lfo.connect(lg).connect(o.frequency);
  const t = a.currentTime;
  g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.16, t + 0.05);
  g.gain.setValueAtTime(0.16, t + seconds - 0.2); g.gain.exponentialRampToValueAtTime(0.0001, t + seconds);
  o.connect(g).connect(out(a));
  o.start(t); lfo.start(t); o.stop(t + seconds + 0.05); lfo.stop(t + seconds + 0.05);
}

// soft sparkle for the logo intro (synth, no file)
export function playIntroChime() {
  if (!on("intro")) return;
  const a = audio(); if (!a) return;
  const go = () => {
    [1568, 2093, 2637, 3136, 4186].forEach((f, i) => tone(a, f, i * 0.07, 0.9 - i * 0.08, "sine", 0.05));
    [2349, 3520].forEach((f, i) => tone(a, f, 0.42 + i * 0.09, 0.7, "triangle", 0.025));
  };
  if (a.state === "running") go(); else a.resume().then(() => a.state === "running" && go()).catch(() => {});
}
